import { render, staticRenderFns } from "./verifyPage.vue?vue&type=template&id=52404073&scoped=true&"
import script from "./verifyPage.vue?vue&type=script&lang=js&"
export * from "./verifyPage.vue?vue&type=script&lang=js&"
import style0 from "./verifyPage.vue?vue&type=style&index=0&id=52404073&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52404073",
  null
  
)

export default component.exports